import React from 'react';
import styled from 'styled-components';
import {
  CollectionDropdown,
  SortCollectionMobile,
} from '@/components/molecules';
import { ISortCollectionCmp } from './ISortCollectionCmp';

interface IStyledProps {
  isMobile?: boolean;
}

const DropdownContainer = styled.div<IStyledProps>`
  min-width: 160px;
`;

const SortCollection: React.FC<ISortCollectionCmp> = ({
  sortSelected,
  isMobile,
  sortChangeHandler,
  collectionSortOptions,
}) => {
  return (
    <>
      {isMobile && sortChangeHandler ? (
        <SortCollectionMobile
          sortSelected={sortSelected}
          sortChangeHandler={sortChangeHandler}
          collectionSortOptions={collectionSortOptions}
        />
      ) : (
        <DropdownContainer>
          <CollectionDropdown
            sortSelected={sortSelected}
            collectionSortOptions={collectionSortOptions}
          />
        </DropdownContainer>
      )}
    </>
  );
};

export default SortCollection;
